<template>
    <div class="con">
        <div class="oneCon">
            <div class="one">
                <div class="left">
                    <p>{{$t('foot').title0}}</p>
                    <p>{{$t('foot').title1}}</p>
                    <input type="text" :placeholder="$t('foot').title4" v-model="form.email">
                </div>
                <div class="line"></div>
                <div class="center">
                    <p>{{$t('foot').title3}}</p>
                    <p @click="send">
                        <span>{{$t('foot').title5}}</span>
                        <i class="iconfont icon-jt"></i>
                    </p>
                </div>
                <div class="right">
                    <img src="../assets/home/code.png" alt="">
                    <p>{{$t('foot').title6}}</p>
                    <p>{{$t('foot').title7}}</p>
                </div>
            </div>
        </div>
        <div class="twoCon">
            <div class="two">
                <div class="left">
                    <div>
                        <img src="../assets/home/footLogo.png" alt="">
                        <p></p>
                    </div>
                    <p class="ph">400-100-5508</p>
                    <p>AOMATE MARKETING DEPARTMENT</p>
                </div>
                <div class="right" v-for="(item,index) in rightList" :key="index">
                    <p v-for="(i,ind) in item.conList" :key="ind" @click="goto(index,ind)">{{i}}</p>
                </div>
            </div>
        </div>
        <div class="main1">
        <div class="left">
          <i class="iconfont icon-tubiao-"></i>
            <i class="iconfont icon-tuite"></i>
            <i class="iconfont icon-ins"></i>
            <i class="iconfont icon-youtobe" style="font-size: 25px;"></i>
            <i class="iconfont icon-guge"></i>
        </div>
        <div>
            <a href="https://beian.miit.gov.cn/" target="_blank">{{$t('foot').title8}}</a>
            <a href="/privacy.html">&nbsp;隐私政策</a>
        </div>
            
            
            <a href="https://www.seniorweb.cn/" target="_blank">{{$t('foot').title9}}</a>
        </div>
        <div style="width:300px;margin:0 auto; padding:20px 0;">
          <a target="_blank" href="" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../assets/beian.jpg" style="float:left;"/><p style="float:left;font-size:14px;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">浙公网安备 33020602000524号</p></a>
        </div>
    </div>
</template>

<script>
    import  qs from 'qs'
    import {getProductsUrl} from '../util/lang'
    export default {
        name: "foot",
        data(){
            return{
                form:{email:''},
                rightList:[],
                proList:[
                    'box',
                    'plastic box',
                    'plastic box'
                ]
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.rightList=this.$t('foot').rightList
                if(this.$i18n.locale === 'en'){
                    this.getProducts('43')
                }else{
                    this.getProducts('42')
                }
            })
        },
        methods:{
            getProducts(id){
                const url = `${getProductsUrl(this.$i18n.locale,id,1000,1)}`
                this.$axios.get(url).then(res => {
                    res.data.proarr=res.data.proarr.slice(0,5)
                    res.data.proarr.map((item)=>{
                        this.rightList[1].conList.push(item.PRONAME)
                    })
                    // console.log(this.rightList)
                })
            },
            send(){
                if(this.form.email===''){
                    this.$notify({
                        title: 'Prompt',
                        message: 'Please Complete',
                        offset: 100
                    });
                }else{
                    this.$nextTick(()=>{
                        const url ='/php/form.php'
                        this.$axios.post(url,
                            qs.stringify(
                                this.form
                            )
                        ).then(res => {
                            if(res.status==200)
                            {
                                this.$notify({
                                    title: 'Success',
                                    message: 'Submitted successfully',
                                    offset: 100
                                })
                                this.form={
                                    email:'',
                                }
                            }else{
                                this.$notify({
                                    title: 'Failure',
                                    message: 'Submission Failed',
                                    offset: 100
                                });
                            }
                        })
                    })
                }
            },
            goto(i,n){
                if(i===0 && n===0){
                    let  link = `/about.html`
                    window.open(link) // this.project.link
                }else if(i===0 && n!==0){
                    let  link = `/about.html?index=${n-1}`
                    window.open(link) // this.project.link
                }else if(i===1 && n===0){
                    let  link = `/pro.html`
                    window.open(link) // this.project.link
                }else if(i===1 && n===1){
                    if(this.$i18n.locale === 'en'){
                        let  link = `/proInfo.html?id=${254}`
                        window.open(link) // this.project.link
                    }else{
                        let  link = `/proInfo.html?id=${240}`
                        window.open(link) // this.project.link
                    }
                }else if(i===1 && n===2){
                    if(this.$i18n.locale === 'en'){
                        let  link = `/proInfo.html?id=${255}`
                        window.open(link) // this.project.link
                    }else{
                        let  link = `/proInfo.html?id=${241}`
                        window.open(link) // this.project.link
                    }
                }
                else if(i===1 && n===3){
                    if(this.$i18n.locale === 'en'){
                        let  link = `/proInfo.html?id=${257}`
                        window.open(link) // this.project.link
                    }else{
                        let  link = `/proInfo.html?id=${243}`
                        window.open(link) // this.project.link
                    }
                }
                else if(i===1 && n===4){
                    if(this.$i18n.locale === 'en'){
                        let  link = `/proInfo.html?id=${260}`
                        window.open(link) // this.project.link
                    }else{
                        let  link = `/proInfo.html?id=${246}`
                        window.open(link) // this.project.link
                    }
                }
                else if(i===1 && n===5){
                    if(this.$i18n.locale === 'en'){
                        let  link = `/proInfo.html?id=${265}`
                        window.open(link) // this.project.link
                    }else{
                        let  link = `/proInfo.html?id=${251}`
                        window.open(link) // this.project.link
                    }
                }
                else if(i===2 && n===0){
                    let  link = `/news.html`
                    window.open(link) // this.project.link
                }else if(i===2 && n!==0){
                    let  link = `/news.html?index=${n-1}`
                    window.open(link) // this.project.link
                }else if(i===3 && n===0){
                    let  link = `/human.html`
                    window.open(link) // this.project.link
                }else if(i===3 && n!==0){
                    let  link = `/human.html?index=${n-1}`
                    window.open(link) // this.project.link
                }else if(i===4 && n===0){
                    let  link = `/tele.html`
                    window.open(link) // this.project.link
                }else if(i===4 && n!==0){
                    let  link = `/tele.html?index=${n-1}`
                    window.open(link) // this.project.link
                }else if(i===5){
                    let  link = `/contact.html`
                    window.open(link) // this.project.link
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    background-color:#282828;
    .oneCon{
        width:100%;
        border-bottom: 1px solid rgba(245, 245, 245,.3);
        padding: 50px 0;
        .one{
            width:90%;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            p{
                color:white;
                padding:10px 0;
            }
            .left{
                width:30%;
                p:nth-child(1){
                    font-family: "Fira Code Medium";
                    font-weight: lighter;
                }
                p:nth-child(2){
                    font-size: 28px;
                }
                input{
                    width:100%;
                    background-color: transparent;
                    border: none;
                    font-style: italic;
                    font-size: 14px;
                    color:rgba(245, 245, 245,.3);
                    border-bottom: 1px solid rgba(245, 245, 245,.3);
                    padding: 10px 0;
                }
                input:focus{
                    border: none;
                    border-bottom: 1px solid rgba(245, 245, 245,.3)!important;
                }
            }
            .line{
                width:1px;
                height:90px;
                background-color: rgba(255,255,255,.3);
                margin-top: 20px;
            }
            .center{
                padding-top:40px;
               font-family: "Fira Code Medium";
                font-weight: lighter;
                width:30%;
                p:nth-child(2){
                    padding-top: 20px;
                    display: flex;
                    flex-direction: column;
                    transition: all 2s;
                    cursor: pointer;
                    span{
                        font-size: 14px;
                        transition: all 2s;
                    }
                    i{
                        font-size:40px;
                        transition: all 2s;
                    }
                }
                p:nth-child(2):hover{
                    transform: translateX(30px);
                    span,i{
                        color:#F7BC30;
                    }
                }
            }
            .right{
                text-align: center;
                p{
                    font-family: "Fira Code Medium";
                    font-weight: lighter;
                    font-size: 14px;
                }
            }
        }
    }
    .twoCon{
        width:100%;
        border-bottom: 1px solid rgba(245, 245, 245,.3);
        padding: 40px 0;
         .two{
             width:90%;
             margin: 0 auto;
             display: flex;
             flex-direction: row;
             font-size: 12px;
             justify-content: space-between;
             .left{
                 text-align: left;
                 color:#B2B2B2;
                 padding-top: 18px;
                 p{
                     color:white;
                     text-align: center;
                     letter-spacing: 1px;
                     transition: all 2s;
                 }
                 .ph{
                     font-size: 30px;
                     padding-top: 20px;
                     padding-bottom: 10px;
                 }
                 p:hover{
                     color:#F5AC01;
                 }
             }
             .right{
                 display: flex;
                 flex-direction: column;
                 padding-left: 30px;
                 padding-right: 30px;
                 margin-left: 2%;
                 text-align: left;
                 p{
                     cursor: pointer;
                     transition: all 2s;
                     color:#CFCFCF;
                     text-align: center;
                     line-height: 30px;
                     font-family: "Fira Code Medium";
                     font-weight: lighter;
                 }
                 p:first-child{
                     font-size: 14px;
                     color:white;
                 }
                 p:hover{
                     color:#F5AC01;
                 }
             }
         }
    }
    .main1{
        width:90%;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 15px 0;
        .left{
            width:10%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            i{
                font-size: 20px;
                color:#B6B6B6;
                cursor: pointer;
                transition: all 2s;
            }
            i:hover{
                color:#F5AC01;
            }
        }
        p,a{
            font-size: 14px;
            color:#909090;
            cursor: pointer;
            transition: all 2s;
        }
        p:hover{
            color:#F5AC01;
        }
        a:hover{
            color:#F5AC01;
        }
    }
    @media screen and (max-width:1680px){
    .twoCon{
        .two{
            width:95%;
            .right{
                padding: 0;
                p{
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                }
            }
        }
    }
    }
    @media screen and (max-width:450px){
        .oneCon{
            .one{
                flex-direction: column;
                .left,.center,.line{
                    display: none;
                }
            }
        }
        .twoCon{
            .two{
                flex-direction: column;
                .left{
                    div{
                        text-align: center;
                    }
                }
                .right{
                    display: none;
                }
            }
        }
        .main1{
            flex-direction: column;
            .left{
                width:100%;
                padding: 10px 0;
            }
            p,a{
                line-height: 30px;
                text-align: center;
            }
        }
    }
}
</style>
